const deleteQueue = async ({ params, api }) => {
  const { previousData } = params;
  const { id } = previousData;
  return await api(`queue/${id}`, { body: { id }, method: 'DELETE' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default deleteQueue;
